import React from "react";
import { NavLink } from "react-router-dom";
import info from "../../../../assets/img/admin/res/information.svg";
const AdminResidencesInfo = ({inforesidencedetail}) => {

  return (
    <div className="AdminBox mt-[40px]">
      <div className="flex gap-[8px] items-center">
        <img src={info} />
        <p className="text-[#292D32] text-[20px] font-[700]">
          اطلاعات اقامتگاه
        </p>
      </div>
      <p className="text-[#5B5F64] text-[14px] font-[400] mb-[24px] mr-[37px]">
        قابل تغیر از طریق پنل{" "}
        <NavLink className="text-[#00A6A6]" to="/create">
          {" "}ساخت اقامتگاه
        </NavLink>
      </p>
      <div className="text-[#12171C] text-[18px] font-[500] AdminBox-shodow p-[20px]  ">
        <h5>حداقل و حداکثر مدت رزرو</h5>
        <p className="text-[#5B5F64] text-[14px] font-[400] mb-[24px] mr-[37px]">
          حداقل مدت رزرو :<span className="text-[#00A6A6]"> {inforesidencedetail.min_stay} روز</span> |
          حداکثر مدت رزرو :<span className="text-[#00A6A6]">  {inforesidencedetail.max_stay} روز</span>
        </p>
      </div>
      <div className="text-[#12171C] text-[18px] font-[500] AdminBox-shodow p-[20px] my-[16px] ">
        <h5>تخفیفات کلی</h5>
        <p className="text-[#5B5F64] text-[14px] font-[400] mb-[24px] mr-[37px]">
          <ul className=" list-disc text-left ">
            <li>
            تخفیف رزرو کوتاه مدت : <span className="text-[#00A6A6]">{inforesidencedetail.short_discount
} %</span>
            </li>
            <li>
              تخفیف رزرو بلند مدت : <span className="text-[#00A6A6]">{inforesidencedetail.long_discount
} %</span>
            </li>
          </ul>
        </p>
      </div>
      <div className="text-[#12171C] text-[18px] font-[500] AdminBox-shodow p-[20px] my-[16px] ">
        <h5>مجوز ها</h5>
        <p className="text-[#5B5F64] text-[14px] font-[400] mb-[24px] mr-[37px]">
          <ul className=" list-disc text-left ">
            <li>
              مجوز پروانه گردشگری :{" "}
            { inforesidencedetail.has_residence_document ? <span className="text-[#00A6A6]">موجود می باشد</span>
            :
            <span className="text-[#F11F1F]">موجود نمی باشد</span>
            }
            </li>
            <li>
              مجوز سند ملک :{" "}
              { inforesidencedetail.has_owner_certificate ? <span className="text-[#00A6A6]">موجود می باشد</span>
            :
            <span className="text-[#F11F1F]">موجود نمی باشد</span>
            }
            </li>
          </ul>
        </p>
      </div>
    </div>
  );
};

export default AdminResidencesInfo;
